import React from "react";
import { ClipboardCheckIcon, HomeIcon, MessageCircleIcon } from "lucide-react";
const steps = [{
  title: "Tell us about your home",
  text: "Choose the system you are considering, then share your name, phone number and Perth suburb.",
  icon: MessageCircleIcon
}, {
  title: "Talk with a specialist",
  text: "We clarify your rooms, current system, priorities and project stage so the next step is relevant.",
  icon: HomeIcon
}, {
  title: "Receive a considered quote",
  text: "The recommended Rinnai solution is based on your home, not a generic online unit price.",
  icon: ClipboardCheckIcon
}];
export function QuoteProcess() {
  return <section className="border-b border-line bg-white py-6 lg:py-8" aria-labelledby="process-title" data-id="element-88" data-mp="9oorl1wjhddv">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-10" data-id="element-89" data-mp="26hgxtvywl9nl">
        <div className="grid gap-8 lg:grid-cols-[0.65fr_1.35fr] lg:items-start" data-id="element-90" data-mp="26jbhl6yfuvq3">
          <div data-id="element-91" data-mp="2bgtrazka5ez5">
            <p className="text-sm font-bold text-rinnai" data-id="element-92" data-mp="2biec3xgsljjt">WHAT HAPPENS NEXT</p>
            <h2 id="process-title" className="mt-3 text-3xl font-bold tracking-[-0.035em]" data-id="element-93" data-mp="1y4xzdgc1g8to">A clearer path to the right system.</h2>
          </div>
          <ol className="grid gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-3" data-id="element-94" data-mp="1odjwqzosiswb">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <li key={step.title} className="bg-white p-6" data-id="element-95" data-mp="2h2r1igeu8eq0" data-mpi={index}>
                  <div className="flex items-center justify-between" data-id="element-96" data-mp="2gzv54win1y3o">
                    <Icon className="h-5 w-5 text-rinnai" aria-hidden="true" data-id="element-97" data-mp="2c3nxmzalgejm" />
                    <span className="text-xs font-bold text-muted" data-id="element-98" data-mp="280hui0is33hd">0{index + 1}</span>
                  </div>
                  <h3 className="mt-5 font-bold" data-id="element-99" data-mp="231odvz872wcz">{step.title}</h3>
                  <p className="mt-2 text-sm leading-6 text-muted" data-id="element-100" data-mp="wm470wrxsq1v">{step.text}</p>
                </li>;
          })}
          </ol>
        </div>
      </div>
    </section>;
}